import { Track } from '../../../classes/track'
import { trimSpecialCharacters } from './remove-garbage'
import { TrackFields } from '../../../constants'

const mixWithoutParenthesisRegex = /(( - .*)|original mix|extended mix|club mix|radio edit)$/i

export function findTracksWithMissingParenthesis(tracks: Track[]) {
  return tracks.filter(t => mixWithoutParenthesisRegex.test(t.title))
}

export function addMixParenthesis(track: any, values: any[]): string {
  const field: TrackFields = values[0]
  let s: string = track[field]

  const group = mixWithoutParenthesisRegex.exec(s)

  if (group) {
    let match: string = group[1]

    if (match) {
      match = trimSpecialCharacters(match)

      const matchWithParenthesis = `(${match})`

      if (s.toLowerCase().includes(matchWithParenthesis.toLowerCase())) {
        s = s.replace(matchWithParenthesis, '')
      }

      const matchIndex = s.indexOf(group[1])

      s = s.slice(0, matchIndex).trim() + ' ' + matchWithParenthesis
    }
  }

  s = s.trim()

  // Fix double parenthesis
  while (s.includes('((') || s.includes('))')) {
    s = s.replace('((', '(').replace('))', ')')
  }

  return s
}
